import type { Bid } from 'prebid.js'

export function getSspAuctionId(bid: Bid | undefined): string | undefined {
    if (bid?.bidder !== 'playgama') {
        return undefined
    }
    const auctionId = bid.meta?.pgAuctionId
    return typeof auctionId === 'string' ? auctionId : undefined
}
